<template>
  <div>
    <div class="page" v-if="edit">
      <div class="title"> 抄表登记 </div>
      <el-divider></el-divider>
      <div class="content" :style="{ height: contentHeight }">
        <sirui-search
          ref="baseInfoFormRef"
          :query="form"
          :columns="formColumn"
          :rules="rules"
          :isQueryPanel="false"
          style="width: 100%"
        ></sirui-search>
      </div>
      <!-- 底部按钮 fixme需要判断立项状态显示-->
      <footer class="bottomButtons">
        <el-row class="page-row">
          <el-button type="primary" @click="confirmClick" :disabled="btnDisabled">确认</el-button>
        </el-row>
      </footer>
    </div>
    <div class="success-page" v-if="!edit">
      <div>
        <i class="el-icon-success"></i>
        <div style="font-size: 20px; margin-top: 20px; margin-bottom: 60px"> 操作成功! </div>
        <el-button style="width: 200px" type="primary" @click="backClick">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import mixin from './mixin.js';
  import moment from 'moment';
  export default {
    name: 'MeterRefistration',
    mixins: [mixin],
    computed: {
      contentHeight() {
        return window.innerHeight - 100 + 'px';
      },
    },
    data() {
      return {
        activeNames: ['1', '2'],
        storageAttachment: [], //附件列表
        edit: true,
        form: {
          energyType: '', //能耗表类型
          companyCode: '',
          spaceAreaId: '', //区域
          spaceAssetId: '', //资产
          spaceUnitId: '', //单元
          spaceFloorId: '', //楼层
          spaceId: '', //房号
          customerName: '', //客户名称
          customerCode: '',
          waterMeterNo: '', //水表编号
          waterMeterType: '', //水表类型
          electricMeterNo: '', //电表编号
          electricMeterType: '', //电表类型
          readMeterDate: '', //抄表日期
          readMeterMonthStart: '',
          readMeterMonthEnd: '',
          periodStartRead: '',
          periodEndRead: '',
          currentMonthRead: '',
          remark: '',
        },
        // fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        spaceAreaDisabled: true,
        spaceAreaList: [],
        spaceAssetDisabled: true,
        spaceAssetList: [],
        spaceUnitDisabled: true,
        spaceUnitList: [],
        spaceFloorDisabled: true,
        spaceFloorList: [],
        spaceDisabled: true,
        spaceList: [],
        companyList: [],
        meterDetail: {},
        meterList: [],
        meterReadingWarning: '',
        removeMeterNo: false,
        removeSpace: false,
        allMeterList: [], //完整水表
        rules: {
          waterMeterNo: [{ required: true, message: '请选择水表编号', trigger: 'blur' }],
          electricMeterNo: [{ required: true, message: '请选择电表编号', trigger: 'blur' }],
          readMeterMonthStart: [{ required: true, message: '请选择抄表月份', trigger: 'blur' }],
          readMeterMonthEnd: [
            { required: true, message: '请选择抄表月份', trigger: 'blur' },
            { validator: this.checkEndTime, trigger: 'change' },
          ],
          // customerName: [{ required: true, message: '请选择客户名称', trigger: 'blur' }],
          periodStartRead: [{ required: true, message: '请输入期初水表读数', trigger: 'blur' }],
          periodEndRead: [
            { required: true, message: '请输入期末水表读数', trigger: 'blur' },
            { validator: this.checkEndRead, trigger: 'change' },
          ],
          currentMonthRead: [
            { required: true, message: '请设置当月读数', trigger: 'blur' },
            { required: true, validator: this.checkCurrentMonthRead, trigger: 'change' },
          ],
          readMeterDate: [{ required: true, message: '请选择抄表日期', trigger: 'blur' }],
          // waterPriceMonth: [{ required: true, message: '请选择水价月份', trigger: 'blur' }],
          // electricPriceMonth: [{ required: true, message: '请选择电价月份', trigger: 'blur' }],
          accountPeriod: [{ required: true, message: '请选择业务账期', trigger: 'blur' }],
        },
      };
    },
    mounted() {
      this.form.companyCode = this.userInfo.companyCode;
      console.log('this.userInfo', this.userInfo);
      this.form.readMeterDate = moment(new Date()).format('YYYY-MM-DD');
      // this.form.waterMeterNo = this.$route.query.meterNo;
      // this.getWaterMeterList();
      this.getCompany();
      //请求数据
    },
    methods: {
      //校验结束时间
      checkEndTime(rule, value, callback) {
        if (!value) {
          callback(new Error('请选择结束时间'));
        } else {
          if (!this.form.readMeterMonthStart) {
            callback(new Error('请选择开始时间！'));
          } else if (Date.parse(this.form.readMeterMonthStart) > Date.parse(value)) {
            callback(new Error('结束时间必须大于开始时间！'));
          } else {
            callback();
          }
        }
      },
      checkEndRead(rule, value, callback) {
        if (!value) {
          callback(new Error('请输入期末读数'));
        } else {
          if (!this.form.periodStartRead) {
            callback(new Error('请输入期初读数'));
          } else if (this.form.periodStartRead - 0 > value - 0) {
            callback(new Error('期末读数必须大于期初读数！'));
          } else {
            callback();
          }
        }
      },
      checkCurrentMonthRead(rule, value, callback) {
        if (!value) {
          callback(new Error('请设置当月读数'));
        } else {
          if (!this.form.currentMonthRead) {
            callback(new Error('请设置当月读数'));
          } else if (this.meterReadingWarning != null && this.meterReadingWarning - 0 < value - 0) {
            callback(new Error('当月读数超过预警值，请核实！'));
          } else {
            callback();
          }
        }
      },
      // 改变能耗表类型
      changeEnergyType(val) {
        this.waterMeterList = [];
        this.electricmeterList = [];
        for (const key in this.form) {
          if (!['companyCode', 'energyType', 'readMeterDate'].includes(key)) {
            this.form[key] = '';
          }
        }
        console.log('改变能耗表类型', val);
        if (val == '02') {
          this.getElectricMeterList();
          console.log('111111111');
        } else if (val == '01') {
          this.getWaterMeterList();
          console.log('222222222');
        }
      },
      backClick() {
        for (const key in this.form) {
          if (!['companyCode', 'energyType', 'readMeterDate'].includes(key)) {
            this.form[key] = '';
          }
        }
        this.edit = true;
      },
      confirmClick() {
        this.$confirmAction('', '您确定要保存吗？', '确认', '返回修改', {
          customClass: 'message-logout',
        }).then(() => {
          this.rules.currentMonthRead[1] = {};
          this.$refs.baseInfoFormRef.validate((valid) => {
            if (valid) {
              this.registerPost();
            }
          });
        });
      },
      async registerPost() {
        var spaceAreaName = '';
        var spaceAssetName = '';
        var spaceUnitName = '';
        var spaceFloorName = '';
        var spaceName = '';
        var companyName = '';
        if (this.form.companyCode != '') {
          let index = this.companyList.findIndex(
            (item) => item.personCompanyCode == this.form.companyCode
          );
          if (index != -1) {
            companyName = this.companyList[index].personCompanyName;
          }
        }
        if (this.form.spaceAreaId != '') {
          let index = this.spaceAreaList.findIndex((item) => item.id == this.form.spaceAreaId);
          if (index != -1) {
            spaceAreaName = this.spaceAreaList[index].name;
          }
        }
        if (this.form.spaceAssetId != '') {
          let index = this.spaceAssetList.findIndex((item) => item.id == this.form.spaceAssetId);
          if (index != -1) {
            spaceAssetName = this.spaceAssetList[index].name;
          }
        }
        if (this.form.spaceUnitId != '') {
          let index = this.spaceUnitList.findIndex((item) => item.id == this.form.spaceUnitId);
          if (index != -1) {
            spaceUnitName = this.spaceUnitList[index].name;
          }
        }
        if (this.form.spaceFloorId != '') {
          let index = this.spaceFloorList.findIndex((item) => item.id == this.form.spaceFloorId);
          if (index != -1) {
            spaceFloorName = this.spaceFloorList[index].name;
          }
        }
        if (this.form.spaceId != '') {
          let index = this.spaceList.findIndex((item) => item.id == this.form.spaceId);
          if (index != -1) {
            spaceName = this.spaceList[index].name;
          }
        }
        this.rules.currentMonthRead[1] = {
          required: true,
          validator: this.checkCurrentMonthRead,
          trigger: 'change',
        };
        let params = [];
        if (this.form.energyType == '01') {
          params = {
            ...this.form,
            waterMeterId: this.form.waterMeterNo,
            attachments: this.storageAttachment,
            waterCompanyNo: this.form.companyCode,
            waterCompanyName: companyName,
            spaceAreaName: spaceAreaName,
            spaceAssetName: spaceAssetName,
            spaceUnitName: spaceUnitName,
            spaceFloorName: spaceFloorName,
            spaceName: spaceName,
          };
          this.$axios.post(MeterAPI.WATER_METER_READ_ADD, params).then((res) => {
            if (res.data.code == 0) {
              // this.$message.success('操作成功');
              this.edit = false;
            } else {
              if (res.data.msg != '') {
                return this.$message.error(res.data.msg);
              }
              this.$message.error('操作失败');
            }
          });
        } else if (this.form.energyType == '02') {
          params = {
            ...this.form,
            electricMeterId: this.electricMeterId,
            attachments: this.storageAttachment,
            electricCompanyNo: this.form.companyCode,
            electricCompanyName: companyName,
            spaceAreaName: spaceAreaName,
            spaceAssetName: spaceAssetName,
            spaceUnitName: spaceUnitName,
            spaceFloorName: spaceFloorName,
            spaceName: spaceName,
          };
          this.$axios.post(MeterAPI.READ_SAVE, params).then((res) => {
            if (res.data.code == 0) {
              // this.$message.success('操作成功');
              this.edit = false;
            } else {
              if (res.data.msg != '') {
                return this.$message.error(res.data.msg);
              }
              this.$message.error('操作失败');
            }
          });
        }
      },

      //获取水表列表数据
      async getWaterMeterList() {
        const { data } = await this.$axios.post(MeterAPI.WATER_METER_LIST, {
          effectiveStatus: '2',
          companyCode: this.form.companyCode,
        });
        if (data.code == 0) {
          this.allMeterList = data.data;
          this.meterList = this.allMeterList;
        }
      },
      //获取电表列表数据
      async getElectricMeterList() {
        const { data } = await this.$axios.post(MeterAPI.METER_LIST, {
          effectiveStatus: '2',
          companyCode: this.form.companyCode,
        });
        if (data.code == 0) {
          this.allMeterList = data.data;
          this.meterList = this.allMeterList;
        }
      },
      // 水表详情
      async getWaterDetail() {
        const { data } = await this.$axios.get(
          `${MeterAPI.WATER_METER_TREE}/${this.form.waterMeterNo}`
        );
        if (data.code == 0) {
          // if ((data.data.waterMeter.companyCode || '') != '') {
          //   this.form.companyCode = data.data.waterMeter.companyCode;
          // }
          if (data.data.spaces != null && data.data.spaces.length > 0) {
            let arr = data.data.spaces[0].space?.parentStr.split('/');

            if (arr.length == 5) {
              for (let i = 0; i < arr.length - 1; i++) {
                this.getSpaceType(i, arr[i]);
              }
              this.form.spaceId = arr[4];
            } else {
              for (let i = 0; i < arr.length; i++) {
                this.getSpaceType(i, arr[i]);
              }
            }
          } else {
            this.form.spaceAreaId = '';
            this.removeSpace = true;
          }
          if (data.data.leaseContract != null) {
            this.form.customerName = data.data.leaseContract.customerName; //客户名称
            this.form.customerCode = data.data.leaseContract.customerCode; //客户名称
          }
          this.form.waterMeterType = data.data.waterMeter.meterType || '1' + ''; //水表类型
          this.meterReadingWarning = data.data.waterMeter.meterReadingWarning; //抄表预警值
          this.form.transformer = data.data.waterMeter.transformer || '' + '';
          this.form.floorMeterNo = data.data.waterMeter.floorMeterNo;
          this.form.floorMeterName = data.data.waterMeter.floorMeterName;
          this.form.unitMeterNo = data.data.waterMeter.unitMeterNo;
          this.form.unitMeterName = data.data.waterMeter.unitMeterName;
          this.form.masterMeterNo = data.data.waterMeter.masterMeterNo;
          this.form.masterSpaceName = data.data.waterMeter.masterSpaceName;
        }
      },
      getSpaceType(index, id) {
        console.log('设置空间值', id);
        if (index == 0) {
          this.form.spaceAreaId = id;
        } else if (index == 1) {
          this.form.spaceAssetId = id;
        } else if (index == 2) {
          this.form.spaceUnitId = id;
        } else if (index == 3) {
          this.form.spaceFloorId = id;
        }
      },

      // 水表抄表详情
      async getWaterReadDetail(meterNo) {
        const { data } = await this.$axios.get(`${MeterAPI.WATER_METER_READ_DETAIL}/${meterNo}`);
        if (data.code == 0) {
          if (data.data.readRegisterVO != null) {
            this.form.readMeterMonthStart = data.data.readRegisterVO.readMeterMonthStart;
            this.form.readMeterMonthEnd = data.data.readRegisterVO.readMeterMonthEnd;
            this.form.periodStartRead = '' + (data.data.readRegisterVO.periodEndRead || '');
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '' + (data.data.readRegisterVO.currentMonthRead || '');
            // this.form.remark = data.data.readRegisterVO.remark;
            this.storageAttachment = data.data.readRegisterVO.attachments;
          }
        }
      },
      // 电表详情
      async getElectricDetail() {
        const { data } = await this.$axios.get(
          `${MeterAPI.ELECTRIC_METER}/${this.form.electricMeterNo}`
        );
        if (data.code == 0) {
          // if ((data.data.electricMeter.companyCode || '') != '') {
          //   this.form.companyCode = data.data.electricMeter.companyCode;
          // }
          if (data.data.spaces != null && data.data.spaces.length > 0) {
            let arr = data.data.spaces[0].space?.parentStr.split('/');

            if (arr.length == 5) {
              for (let i = 0; i < arr.length - 1; i++) {
                this.getSpaceType(i, arr[i]);
              }
              this.form.spaceId = arr[4];
            } else {
              for (let i = 0; i < arr.length; i++) {
                this.getSpaceType(i, arr[i]);
              }
            }
          } else {
            this.form.spaceAreaId = '';
            this.removeSpace = true;
          }
          this.electricMeterId = data.data.electricMeter.id; //电表ID
          this.meterReadingWarning = data.data.electricMeter.meterReadingWarning; //抄表预警值
          if (data.data.electricMeter.inductanceRatio != null) {
            this.form.inductanceRatio = data.data.electricMeter.inductanceRatio.toString();
          }
          if (data.data.electricMeter.loss != null) {
            this.form.loss = data.data.electricMeter.loss.toString();
          }
          if (data.data.leaseContract != null) {
            this.form.customerName = data.data.leaseContract.customerName; //客户名称
            this.form.customerCode = data.data.leaseContract.customerCode; //客户名称
          }
          this.form.electricMeterType = data.data.electricMeter.meterType || '1' + ''; //电表类型
        }
      },
      // 电表抄表详情
      async getElectricReadDetail(meterNo) {
        const { data } = await this.$axios.get(`${MeterAPI.READ_DETAIL}/${meterNo}`);
        if (data.code == 0) {
          if (data.data.readRegisterVO != null) {
            this.form.readMeterMonthStart = data.data.readRegisterVO.readMeterMonthStart;
            this.form.readMeterMonthEnd = data.data.readRegisterVO.readMeterMonthEnd;
            this.form.periodStartRead = '' + (data.data.readRegisterVO.periodEndRead || '');
            this.form.periodEndRead = '';
            this.form.currentMonthRead = '' + (data.data.readRegisterVO.currentMonthRead || '');
            // this.form.remark = data.data.readRegisterVO.remark;
            this.storageAttachment = data.data.readRegisterVO.attachments;
          }
        }
      },
      // 根据片区查询能耗表
      async findSpaceByMeterNo(params) {
        params.energyType = this.form.energyType;
        const { data } = await this.$axios.post(MeterAPI.ENERGY_SPACE, params);
        this.meterList = [];
        if (data.code == 0) {
          if (data.data.length == 1) {
            if (this.form.energyType == '01') {
              this.form.waterMeterNo = data.data[0].energyId.toString();
            } else {
              this.form.electricMeterNo = data.data[0].energyId.toString();
            }
          }
          data.data.forEach((item) => {
            this.meterList.push({
              id: item.energyId.toString(),
              meterNo: item.energyCode,
            });
          });
        }
      },
      //获取公司信息
      async getCompany() {
        const { data } = await this.$axios.post(MeterAPI.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
        });
        if (data.code == 0) {
          console.log('data.data.personCompanyInfo', data.data.personCompanyInfo);
          this.companyList = data.data.personCompanyInfo;
          this.form.companyCode = data.data.personCompanyInfo[0].personCompanyCode;
        }
      },
      // 获取片区数据
      async getArea(value, type) {
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, {
          id: value,
          companyNo: this.form.companyCode,
          effective: false,
        });
        if (data.code == 0) {
          console.log('获取片区数据', type);
          if (type == 'area') {
            this.spaceAreaList = data.data;
            if (this.spaceAreaList.length <= 0) {
              this.form.spaceAreaId = '';
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'asset') {
            this.spaceAssetList = data.data;
            if (this.spaceAssetList.length <= 0) {
              this.form.spaceAssetId = '';
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'unit') {
            this.spaceUnitList = data.data;
            if (this.spaceUnitList.length <= 0) {
              this.form.spaceUnitId = '';
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'floor') {
            this.spaceFloorList = data.data;
            if (this.spaceFloorList.length <= 0) {
              this.form.spaceFloorId = '';
              this.form.spaceId = '';
            }
          } else if (type == 'space') {
            this.spaceList = data.data;
            if (this.spaceList.length <= 0) {
              this.form.spaceId = '';
            }
          }
        }
      },
      // 区域改变，重置水表编号
      resetMeterNo(value) {
        console.log('区域改变了', value);
        this.removeMeterNo = true;
        this.removeSpace = true;
        this.form.waterMeterNo = '';
        this.form.electricMeterNo = '';
      },
    },
  };
</script>
<style scoped lang="scss">
  // ::v-deep .el-input.is-disabled .el-input__inner {
  //   background-color: white;
  // }

  ::v-deep .el-input__inner {
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-divider--horizontal {
    margin: 12px 0;
  }
  .page {
    background-color: white;
    margin-top: 0px;
    height: 100vh;
    top: 0;
    .content {
      // max-height: calc(100% - 120px);

      overflow: auto;
      // padding-bottom: 40px;
    }
    .title {
      text-align: center;
      margin-top: 20px;
      font-size: 18px;
      color: #606266;
      margin-left: 10px;
      font-weight: bolder;
    }
  }
  .success-page {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 500px;
    i.el-icon-success {
      font-size: 70px;
      color: #67c23a;
    }
  }
  ::v-deep .el-button--small {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }

  .bottomButtons {
    position: fixed;
    bottom: 0px;
    height: 40px;
    width: 100%;
  }
</style>
<style>
  .el-message-box {
    width: 300px !important;
  }
  .message-logout {
    width: 350px;
  }
</style>
